module.exports = __webpack_public_path__ + "img/carousel-productos-2.c3e82d9a.jpg";